(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('insurance-relation', {
                parent: 'entity',
                url: '/insurance-relation',
                data: {
                    authorities: [],
                    pageTitle: 'Insurance Relations'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/insurance-relation/list/insurance-relation.html',
                        controller: 'InsuranceRelationController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_INSURANCE_RELATION_CONFIG];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_INSURANCE_RELATION_CONFIG, access);
                }]
            });
    }
})();
